import { isBefore, parseISO, startOfDay } from 'date-fns'
import * as Yup from 'yup'

import { toViewingFormDurationOptions } from '../../../RentalPortalViewing'

import { VIEWING_RESCHEDULE_FIELD_NAME } from './ViewingRescheduleModal.constants'

export function getViewingRescheduleInitialValues({ t, viewingData }) {
  return {
    [VIEWING_RESCHEDULE_FIELD_NAME.duration]:
      toViewingFormDurationOptions(t).find(
        option => option.value === viewingData.duration_min
      ) ?? null,
    [VIEWING_RESCHEDULE_FIELD_NAME.start]: parseISO(viewingData.start),
  }
}

export function getViewingReschedulePayload({ values, viewingData }) {
  return {
    duration_min: values[VIEWING_RESCHEDULE_FIELD_NAME.duration].value,
    start: values[VIEWING_RESCHEDULE_FIELD_NAME.start].toISOString(),
    viewing_id: viewingData.id,
  }
}

export function getViewingRescheduleValidationSchema({ t, viewingData }) {
  return Yup.object({
    [VIEWING_RESCHEDULE_FIELD_NAME.duration]: Yup.object()
      .nullable()
      .required(true),
    [VIEWING_RESCHEDULE_FIELD_NAME.start]: Yup.date()
      .nullable()
      .required(true)
      .test({
        message: t('RentalPortal.ViewingFormPastDateKey'),
        name: 'viewingRescheduleNotPast',
        test: value => !value || !isBefore(value, startOfDay(new Date())),
      })
      .test({
        message: t('RentalPortal.ViewingRescheduleSameSlotKey'),
        name: 'viewingRescheduleDiffers',
        test: value =>
          !value || value.getTime() !== parseISO(viewingData.start).getTime(),
      }),
  })
}
